/**
 * 平台标识工具
 *
 * 基于编译期常量 `__UNI_PLATFORM__`（由 vite.config.ts 的 define 注入）派生的一组平台判断，
 * 用于在运行时区分当前端。本项目编译两端：微信小程序（主体，`isMp` 为 true）与
 * H5 分享落地页（`src/pages-h5`，`isH5` 为 true）；`isApp` 恒为 false。
 *
 * 其中 `platform` 会被请求拦截器（src/http/interceptor.ts）注入到每个请求的 header，
 * 用于告诉后端请求来源。
 */
export const platform = __UNI_PLATFORM__
export const isH5 = __UNI_PLATFORM__ === 'h5'
export const isApp = __UNI_PLATFORM__ === 'app'
export const isMp = __UNI_PLATFORM__.startsWith('mp-')
const PLATFORM = {
  platform,
  isH5,
  isApp,
  isMp,
}
export default PLATFORM
